import Api from "./Api";
import ApiNode from "./ApiNode";

export default {
  getAllUlipList(payload) {
    let getAllUlipList = Api().post("Api_Ulip/getUlipTrack.php", payload);
    return getAllUlipList;
  },
  getAllUlipListV2(payload) {
    return ApiNode().post("ulip/track", payload);
  },
  getAllOEJobsAllList(payload, config) {
    let getAllUlipList = ApiNode().post(
      "get-common-job/get-assignment-wise-data",
      payload,
      config,
    );
    return getAllUlipList;
  },
  getVehicleChallanExcelData(payload, config) {
    let getVehicleChallanData = ApiNode().get(
      "vehicle-challan/excel-data",
      { params: payload },
      config,
    );
    return getVehicleChallanData;
  },
  getJobWiseProfitLossForTally(payload, config) {
    let getJobWiseProfitLossList = ApiNode().post(
      "get-common-job/get-job-wise-profit-loss-for-tally",
      payload,
      config,
    );
    return getJobWiseProfitLossList;
  },
};



// WEBPACK FOOTER //
// ./src/services/UlipService.js